import React from 'react';
import { Navigate } from 'react-router-dom';
import { PARTNER_PORTAL_MY_PROJECTS, PARTNER_PORTAL_PAE_QUEUE } from '../Constants/partnerRoutes';

export const PartnerProjectDetailRedirect = () => {
  return <Navigate to={PARTNER_PORTAL_MY_PROJECTS} replace />;
};

export const PartnerPAEProjectDetailRedirect = () => {
  return <Navigate to={PARTNER_PORTAL_PAE_QUEUE} replace />;
};
